export default "__VITE_ASSET__34494604__"